"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.binomialExpansionThree = exports.binomialExpansionTwo = void 0;
// E.g. (x + 1)(2x - 5) -> productCoefs([1, 1], [2, -5]) -> [2, -3, -5] -> x² - 3x - 5
const productCoefs = (coefs1, coefs2) => coefs1.reduce((product, coef1, i) => {
    for (let j = 0; j < coefs2.length; j++) {
        product[i + j] = (product[i + j] || 0) + coef1 * coefs2[j];
    }
    return product;
}, []);
function multiProductCoefs(coefsArrays) {
    if (coefsArrays.length < 2)
        return coefsArrays[0];
    const [coefs1, ...rest] = coefsArrays;
    return productCoefs(coefs1, multiProductCoefs(rest));
}
const coefsToText = (coefs, symbol) => {
    var _a, _b;
    const powers = ['', '', '²', '³', '⁴', '⁵', '⁶', '⁷', '⁸', '⁹'];
    const regex1 = RegExp(`^1${symbol}`, 'g');
    const regex2 = RegExp(`-1${symbol}`, 'g');
    let terms = coefs
        .map((v, i) => (`${v}${i ? `${symbol}${powers[i]}` : ''}`)
        .replace(regex1, symbol)
        .replace(regex2, `-${symbol}`))
        .filter(v => v[0] !== "0");
    if (terms.length === 0)
        return "0";
    if (terms.length === 2 && ((_a = terms[0]) === null || _a === void 0 ? void 0 : _a[0]) !== "-" && ((_b = terms[1]) === null || _b === void 0 ? void 0 : _b[0]) === "-") {
        terms = terms.reverse();
    }
    return terms.reverse()
        .join(" + ")
        .replace(/\+ -/g, "- ");
};
function binomialExpansionTwo({ a = 0, b = 0, c = 0, d = 0, symbol = 'x' }) {
    const coefs = productCoefs([b, a], [d, c]);
    return coefsToText(coefs, symbol);
}
exports.binomialExpansionTwo = binomialExpansionTwo;
function binomialExpansionThree({ a = 0, b = 0, c = 0, d = 0, e = 0, f = 0, symbol = 'x' }) {
    const coefs = multiProductCoefs([[b, a], [d, c], [f, e]]);
    return coefsToText(coefs, symbol);
}
exports.binomialExpansionThree = binomialExpansionThree;
